import React from 'react';
import {withRouter} from 'react-router-dom';
import LayoutContainer from '../../components/LayoutContainer';
import Title from '../../components/Title';
import Box from '../../components/Box';
import BottomImage from '../../components/BottomImage';
import Button from '../../components/Button';
import MainContainer from '../../components/MainContainer';
import Logo from '../../components/Logo';
import ProgressBar from '../../components/ProgressBar';
import Input from '../../components/Input';
import Label from '../../components/Label';
import SubLabel from '../../components/SubLabel';
import {Field, Form, FormValidation, resetSubmitting, getFormData, untouch} from '@nexios/frontend-forms';
import parse from 'html-react-parser';
import replaceNewLinesForHtml from '../../utils/replaceNewLines';
import ErrorMessage from '../../components/ErrorMessage';
import PaymentFailedMessage from '../../components/PaymentFailedMessage';
import FieldWrapper from '../../components/FieldWrapper';
import _ from 'lodash';
import {cleanseAddress, cleanseName, closeDialog, renderDialog, saveLead} from '../../reducer';
import {gaLead1} from '../../googleAnalytics/lead1';
import {connect} from 'react-redux';
import Validation from '../../components/Validation';
import DateInput from '../../components/DateInput';
import Checkbox from '../../components/Checkbox';
import ProductImage from '../../components/ProductImage';
import RadioButtonContainer from '../../components/RadioButtonContainer';
import {Helmet} from 'react-helmet';
import Telemarketing from '../../components/Telemarketing';
import NewsletterOptIn from '../../components/NewsletterOptIn';
import {optInChoices, normalizeOptIns} from '../../utils/optIn';
import styled, {withTheme} from 'styled-components';
import useScrollToTop from '../../hooks/useScrollToTop';
import Teaser from '../../components/Teaser';
import formatPhone from '@nexios/phone-number-formatter';
import genders from '../../utils/genders';
import orderContactBlocks from '../../utils/orderContactBlocks';
import parseAuthorizeLabel from '../../utils/parsePrivacyStatement';
import ModalDialog from '../../components/ModalDialog';
import TextToHtml from '../../components/TextToHtml';
import SmsOptOut from '../../components/SmsOptOut';
import PrivacyLabel from '../../components/PrivacyLabel';
import DirectDebitText from '../Petition1/DirectDebitText';
import DonationConfirmationAmountText from '../Petition1/DonationConfirmationAmountText';
import RadioButton from '../../components/RadioButton';
import SinglePeriod from '../../components/SingePeriod';
import ButtonContainer from '../../components/ButtonContainer';
import PaymentMethodButtonContainer from '../../components/PaymentMethodButtonContainer';
import Dropdown from '../../components/Dropdown';
import SelectedAmountText from '../../components/SelectedAmountText';
import SelectedFrequencyContent from '../../components/SelectedFrequencyContent';
import InputAmount from '../../components/InputAmount';
import parseAndGetBigNumber from '../../utils/parseAndGetBigNumber';
import {isSepaCountryIban} from '@nexios/validation';
import BigNumber from 'bignumber.js';
import IBAN from 'iban';
import parseText from '../../utils/parseText';
import {wrap as wrapTitle} from '../../components/TitleWrapper';
import DJSBSideBar from '../../components/DJSBSideBar';
import {AddressRow, StyledAddressLabel, HouseNumberRow, FoundAddress, FoundAddressTitle, NoFoundAddress} from '../../components/Address';

const hasValue = val => !_.isNil(val) && _.trim(val) !== '';

const isAddressVisible = ctx => {
  if (ctx.donateAsOrganisation === true) {
    return ctx.organisation.isAddressVisible;
  }

  return ctx.person.isAddressVisible;
};

const getDefaultPeriod = formContext => {
  const periodMapping = {
    threeMonths: '3',
    sixMonths: '6',
    nineMonths: '9',
    twelveMonths: '12'
  };
  return periodMapping[formContext.defaultPeriod];
};

function formatAmount(amount, options = {}) {
  const {
    showCurrencySymbol = true,
    showEuroText = false,
    showDashForWholeNumber = false
  } = options;

  const isWholeNumber = Number.isInteger(Number(amount));
  let formatted = new Intl.NumberFormat('nl-NL', {
    style: showCurrencySymbol ? 'currency' : 'decimal',
    currency: 'EUR',
    minimumFractionDigits: isWholeNumber ? 0 : 2,
    useGrouping: true
  }).format(amount);

  if (isWholeNumber && showDashForWholeNumber) {
    formatted += ',-';
  }

  if (showEuroText) {
    formatted += ' euro';
  }

  return formatted;
}

const onFrequencyChange = (formContext, ctx, setValues, theme) => {
  let frequency = _.get(ctx, ['data', 'frequency']) || formContext.defaultFrequency;
  let frequencyDefinition = formContext.frequencies.find(f => f.value === frequency);
  if (!frequencyDefinition) {
    frequency = formContext.defaultFrequency;
    frequencyDefinition = formContext.frequencies.find(f => f.value === frequency);
  }
  const showIcon = formContext.amountDisplay === 'icon';
  const amounts = frequencyDefinition.amounts.map(a => {
    const name = formatAmount(a.amount_m, {
      showCurrencySymbol: formContext.amountDisplay === 'amount',
      showEuroText: formContext.amountDisplay === 'amountEuroText',
      showDashForWholeNumber: !!theme.showDashForWholeNumberInAmountButtons
    });
    return {
      label: showIcon ? a.label : name,
      value: {
        value: a.amount_m.toString(),
        icon: showIcon ? a.icon : null,
        ribbon: a.amount_m === frequencyDefinition.defaultAmount_m ? frequencyDefinition.defaultRibbon : ''
      }
    };
  });

  if (formContext.customAmountDisplay === 'button' && frequencyDefinition.allowCustomAmount) {
    amounts.push({
      label: 'Anders',
      value: {
        value: true,
        fieldName: 'isCustomAmountVisible',
        icon: null,
        ribbon: ''
      }
    });
  }

  ctx.setList('amounts', amounts);

  let theSelectedAmount = frequencyDefinition.amounts.find(a => a.amount_m === frequencyDefinition.defaultAmount_m);

  if (!theSelectedAmount && frequencyDefinition.amounts.length === 1) {
    theSelectedAmount = frequencyDefinition.amounts[0];
  }

  const values = {
    isCustomAmountVisible: formContext.customAmountDisplay === 'inline' && frequencyDefinition.allowCustomAmount,
    allowCustomAmount: frequencyDefinition.allowCustomAmount,
    amountText: theSelectedAmount ? theSelectedAmount.message : null,
    amountLabel: theSelectedAmount ? theSelectedAmount.label : null,
    customAmount_m: null,
    amount_m: frequencyDefinition.defaultAmount_m || null,
    paymentMethod: frequency === 'oneOff' ? formContext.paymentMethods[0].value : 'directDebit'
  };

  if (formContext.mandateType === 'temporary' && frequencyDefinition.value === 'monthly') {
    values.period = getDefaultPeriod(formContext);
  } else if (formContext.mandateType !== 'temporary' || frequencyDefinition.value !== 'monthly') {
    values.period = null;
  }

  setValues(values);
};

const Lead1 = ({formContext, save, history, cleanseAddress, cleanseName, gaLead1, resetSubmittingForm, next, previous, progressBar, renderDialog, closeDialog, isDialogVisible, untouchAmountFields, theme}) => {
  useScrollToTop();
  let cleansingAddress = false;
  let cleansingName = false;

  const formConfig = {
    onSubmit: (data) => {
      if (cleansingAddress || cleansingName) {
        resetSubmittingForm();
      } else {
        gaLead1(formContext);
        save(history, data);
      }
    },
    onInit: (ctx) => {
      ctx.data = {...ctx}; // hack to reuse change handlers since onDataChanged receives a context where the data is nested in a data property
      const minimumProductQuantity = _.toInteger(formContext.minimumProductQuantity_i);
      const maximumProductQuantity = _.toInteger(formContext.maximumProductQuantity_i);
      const productQuantityStep = _.toInteger(formContext.productQuantityStep_i);
      const defaultProductQuantity = _.toInteger(formContext.defaultProductQuantity_i);
      const showProductQuantity = formContext.showProductQuantity || false;

      if (showProductQuantity === true) {
        const productAmountList = [];

        if (minimumProductQuantity === 1 && maximumProductQuantity === 1) {
          productAmountList.push({
            label: '1',
            value: '1'
          });
        } else {
          for (let i = minimumProductQuantity; i <= maximumProductQuantity; i += productQuantityStep) {
            productAmountList.push({
              label: `${i}`,
              value: `${i}`
            });
          }
        }

        ctx.setList('productAmount', productAmountList);
      }

      ctx.setDefaultValues({
        donateAsOrganisation: _.get(formContext, ['donateAsOrganisationDefault'], false),
        productAmount: showProductQuantity === true ? defaultProductQuantity : 1
      });

      ctx.setList('days', _.range(1, 31).map(value => ({label: `${value}`, value: `${value}`})));
      ctx.setList('genders', genders(formContext));
      ctx.setList('donateAsOrganisationChoices', [
        {label: 'Particulier', value: false},
        {label: 'Bedrijf', value: true}
      ]);
      ctx.setList('optInChoices', optInChoices);

      if (formContext.newsletterOptIn === 'dropdown') {
        const newsletterDefault = _.get(formContext, 'newsletterDefault');
        if (newsletterDefault === true || newsletterDefault === false) {
          ctx.setDefaultValues({
            allowNewsletter: newsletterDefault
          });
        }
      } else if (_.get(formContext, 'newsletterDefault', theme.allowNewsletterDefault) === true) {
        ctx.setDefaultValues({
          allowNewsletter: true
        });
      }

      if (formContext.telemarketingOptIn === 'dropdown') {
        const telemarketingDefault = _.get(formContext, 'telemarketingDefault');
        if (telemarketingDefault === true || telemarketingDefault === false) {
          ctx.setDefaultValues({
            allowTelemarketing: telemarketingDefault
          });
        }
      } else if (formContext.telemarketingOptIn !== 'none' && _.get(formContext, 'telemarketingDefault', true) === true) {
        ctx.setDefaultValues({
          allowTelemarketing: true
        });
      }

      if (formContext.showDonationFieldsQuestionVisible === true) {
        const selectedFrequency = ctx.frequency || formContext.defaultFrequency;
        const frequencyDefinition = formContext.frequencies.find(f => f.value === selectedFrequency);
        const customAmountDisplay = _.get(formContext, ['customAmountDisplay']);
        const showInline = customAmountDisplay === 'inline' && frequencyDefinition.allowCustomAmount;

        const defaultValues = {
          optInAdminCostContribution: formContext.askAdminCostContribution === true ? _.get(formContext, 'adminCostContributionDefault') : false,
          adminCostContributionAmount_m: formContext.adminCostContributionAmount_m,
          frequency: frequencyDefinition ? frequencyDefinition.value : null,
          authorizeLabel: ctx.donateAsOrganisation ? formContext.privacyConfirmationTextOrganisation : formContext.privacyConfirmationTextPerson
        };

        ctx.setList('days', _.range(1, 31).map(value => ({label: `${value}`, value: `${value}`})));
        ctx.setList('idealBanks', formContext.idealBanks);
        ctx.setList('creditCardBanks', formContext.creditCardBanks);
        ctx.setList('paymentMethods', formContext.paymentMethods);
        ctx.setList('frequencies', formContext.frequencies);
        if (formContext.mandateType === 'temporary') {
          const periods = [];
          if (formContext.allowPeriodThreeMonths === true) {
            periods.push({label: 'Stopt automatisch na 3 maanden', value: '3'});
          }
          if (formContext.allowPeriodSixMonths === true) {
            periods.push({label: 'Stopt automatisch na 6 maanden', value: '6'});
          }
          if (formContext.allowPeriodNineMonths === true) {
            periods.push({label: 'Stopt automatisch na 9 maanden', value: '9'});
          }
          if (formContext.allowPeriodTwelveMonths === true) {
            periods.push({label: 'Stopt automatisch na 12 maanden', value: '12'});
          }
          ctx.setList('periods', periods);
          ctx.setDefaultValues({
            period: getDefaultPeriod(formContext)
          });
        }
        ctx.setDefaultValues(defaultValues);
        onFrequencyChange(formContext, ctx, ctx.setDefaultValues, theme);
        ctx.setValues({
          isCustomAmountVisible: showInline || ctx.data.isCustomAmountVisible
        });
      }
    },
    onDataChanged: (ctx, callback) => {
      normalizeOptIns(ctx);
      switch (ctx.field) {
        case 'donateAsOrganisation':
          ctx.validate(true);
          return callback();
        case 'postalCode':
        case 'houseNumber_i':
        case 'houseNumberAddition':
          const postalCode = _.get(ctx, ['data', 'postalCode']);
          const houseNumber = _.get(ctx, ['data', 'houseNumber_i']);
          const houseNumberAddition = _.get(ctx, ['data', 'houseNumberAddition']);

          if (hasValue(postalCode) && hasValue(houseNumber)) {
            // if we are already cleansing do not start again, request may interfer
            if (cleansingAddress) {
              return callback();
            }

            cleansingAddress = true;

            cleanseAddress({
              postalCode,
              houseNumber_i: houseNumber,
              houseNumberAddition
            }, (data) => {
              if (data.status === 500) {
                data = {
                  result: {
                    success: true
                  },
                  address: {
                    street: '',
                    city: ''
                  }
                };
              }

              const addressCleansingStatus = _.get(data, [
                'result',
                'success'
              ], false) ? 'GREEN' : 'RED';

              const cleansedAddress = _.get(data, [
                'result',
                'address'
              ]);

              if (addressCleansingStatus === 'GREEN') {
                ctx.setValues({
                  street: cleansedAddress.street,
                  city: cleansedAddress.city,
                  postalCode: cleansedAddress.postalCode,
                  houseNumber_i: cleansedAddress.houseNumber_i,
                  houseNumberAddition: cleansedAddress.houseNumberAddition,
                  addressCleansingStatus
                });
              } else {
                ctx.setValues({
                  street: null,
                  city: null,
                  addressCleansingStatus
                });
              }

              ctx.validate(true);

              cleansingAddress = false;

              return callback();
            });
          } else if (!hasValue(postalCode) || !hasValue(houseNumber)) {
            ctx.setValues({
              addressCleansingStatus: null,
              street: null,
              city: null
            });
            return callback();
          }
          break;
        case 'initials':
        case 'firstName':
        case 'infix':
        case 'lastName':
          const initials = _.get(ctx, ['data', 'initials']);
          const firstName = _.get(ctx, ['data', 'firstName']);
          const infix = _.get(ctx, ['data', 'infix']);
          const lastName = _.get(ctx, ['data', 'lastName']);

          if (formContext.cleanseName && hasValue(lastName)) {
            // if we are already cleansing do not start again, request may interfer
            if (cleansingName) return callback();

            cleansingName = true;
            let name = {initials, firstName, infix, lastName};

            cleanseName({name}, cleanseNameResult => {
              const decisionStatus = _.get(cleanseNameResult, [
                'result',
                'decisionStatus'
              ]);

              ctx.setValues({
                nameCleansingStatus: decisionStatus
              });

              ctx.validate(true);
              cleansingName = false;

              return callback();
            });
          } else if (!hasValue(lastName)) {
            ctx.setValues({
              nameCleansingStatus: null
            });
            return callback();
          }
          break;
        case 'email':
          const email = _.get(ctx, ['data', 'email']);

          if (hasValue(email)) {
            ctx.setValues({
              email: _.trim(email)
            });
          }
          return callback();
        case 'showDonationFields':
          const selectedFrequency = formContext.defaultFrequency;
          const frequencyDefinition = formContext.frequencies.find(f => f.value === selectedFrequency);
          onFrequencyChange(formContext, ctx, ctx.setValues, theme);
          ctx.setValues({
            frequency: frequencyDefinition ? frequencyDefinition.value : null,
            iban: null,
            bank: null,
            creditCardBank: null,
            giveCompensation: null
          });
          return callback();
        case 'amount_m':
          ctx.setValues({
            customAmount_m: null
          });

          if (formContext.customAmountDisplay === 'button' && hasValue(_.get(ctx, ['data', 'amount_m']))) {
            ctx.setValues({
              isCustomAmountVisible: false
            });
          }
          return callback();
        case 'customAmount_m':
          ctx.setValues({
            amount_m: null
          });
          return callback();
        case 'isCustomAmountVisible':
          if (formContext.customAmountDisplay === 'button' && _.get(ctx, ['data', 'isCustomAmountVisible']) === true) {
            untouchAmountFields();

            ctx.setValues({
              amount_m: null
            });
          }
          return callback();
        case 'frequency':
          const frequency = _.get(ctx, ['data', 'frequency']);
          if (hasValue(frequency)) {
            onFrequencyChange(formContext, ctx, ctx.setValues, theme);
          }
          return callback();
        case 'giveCompensation':
          if (ctx.data.giveCompensation) {
            ctx.setValues({
              frequency: 'oneOff',
              paymentMethod: formContext.paymentMethods[0].value,
              amount_m: formContext.compensationAmount_m
            });
          }
          return callback();
        default:
          return callback();
      }
    },
    fields: {
      telemarketingInfoText: {
        isVisible: ctx => {
          if (ctx.telemarketingOptIn !== 'text' && ctx.telemarketingOptIn !== 'button') {
            return false;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneVisible;
          }

          return ctx.person.isTelephoneVisible;
        },
        isRequired: false
      },
      allowTelemarketing: {
        isVisible: ctx => {
          if (ctx.telemarketingOptIn !== 'checkbox' && ctx.telemarketingOptIn !== 'dropdown') {
            return false;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneVisible;
          }

          return ctx.person.isTelephoneVisible;
        },
        isRequired: false
      },
      renderAsOrganisation: {
        isVisible: ctx => ctx.donateAsOrganisation === true
      },
      renderAsPerson: {
        isVisible: ctx => ctx.donateAsOrganisation !== true
      },
      donateAsOrganisation: {
        isVisible: (ctx) => ctx.allowDonateAsOrganisation === true
      },
      organisationName: {
        isVisible: ctx => ctx.donateAsOrganisation === true,
        isRequired: true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.organisationName) && _.trim(ctx.organisationName) !== '',
            message: theme.showRequiredText && 'Naam organisatie is niet ingevuld'
          }
        ]
      },
      email: {
        isVisible: true,
        isRequired: true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.email) && ctx.email !== '',
            message: theme.showRequiredText && 'E-mailadres is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (_.isNil(ctx.email) || ctx.email === '') {
                return true;
              }

              return /^[-0-9a-zA-Z.+_]{1,63}@([-0-9a-zA-Z+_]+\.){1,63}[a-zA-Z]{1,63}$/.test(_.trim(ctx.email));
            },
            message: 'Er is geen geldig e-mailadres ingevuld.'
          }
        ]
      },
      gender: {
        isVisible: ctx => ctx.donateAsOrganisation !== true && ctx.person.isGenderVisible === true,
        isRequired: ctx => ctx.donateAsOrganisation !== true && ctx.person.isGenderRequired === true,
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true) {
                return true;
              }

              if (ctx.person.isGenderRequired) {
                return !_.isNil(ctx.gender) && _.trim(ctx.gender) !== '';
              }

              return true;
            },
            message: theme.showRequiredText && 'Geslacht is niet ingevuld'
          }
        ]
      },
      initials: {
        isVisible: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isInitialsVisible;
          }

          return ctx.person.isInitialsVisible;
        },
        isRequired: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isInitialsRequired;
          }

          return ctx.person.isInitialsRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true && ctx.organisation.isInitialsRequired) {
                return !_.isNil(ctx.initials) && _.trim(ctx.initials) !== '';
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isInitialsRequired) {
                return !_.isNil(ctx.initials) && _.trim(ctx.initials) !== '';
              }

              return true;
            },
            message: theme.showRequiredText && 'Voorletters is niet ingevuld'
          },
          {
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      firstName: {
        isVisible: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isFirstNameVisible;
          }

          return ctx.person.isFirstNameVisible;
        },
        isRequired: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isFirstNameRequired;
          }

          return ctx.person.isFirstNameRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true && ctx.organisation.isFirstNameRequired) {
                return !_.isNil(ctx.firstName) && _.trim(ctx.firstName) !== '';
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isFirstNameRequired) {
                return !_.isNil(ctx.firstName) && _.trim(ctx.firstName) !== '';
              }

              return true;
            },
            message: theme.showRequiredText && 'Voornaam is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (_.isNil(ctx.firstName) || ctx.firstName === '') {
                return true;
              }

              return _.trim(ctx.firstName).length > 1;
            },
            message: 'Voornaam moet minimaal 2 karakters hebben.'
          },
          {
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      infix: {
        rules: [
          {
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      lastName: {
        isRequired: true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.lastName) && ctx.lastName !== '',
            message: theme.showRequiredText && 'Achternaam is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (_.isNil(ctx.lastName) || ctx.lastName === '') {
                return true;
              }

              return _.trim(ctx.lastName).length > 1;
            },
            message: 'Achternaam moet minimaal 2 karakters hebben.'
          },
          {
            message: () => formContext.cleanseNameMessage || 'Naam is mogelijk niet juist.',
            severity: 'warning',
            isValid: ctx => ctx.nameCleansingStatus === 'GREEN' || _.isEmpty(ctx.nameCleansingStatus)
          }
        ]
      },
      postalCode: {
        isVisible: isAddressVisible,
        isRequired: ctx => {
          if (hasValue(ctx.houseNumber_i) || hasValue(ctx.houseNumberAddition)) {
            return true;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isAddressRequired;
          }

          return ctx.person.isAddressRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (!hasValue(ctx.postalCode)) {
                return true;
              }

              return /^[1-9][0-9]{3}\W?[a-zA-Z]{2}$/.test(_.trim(ctx.postalCode));
            },
            message: 'Er is geen geldige postcode ingevuld.'
          },
          {
            isValid: ctx => {
              if (hasValue(ctx.houseNumber_i) || hasValue(ctx.houseNumberAddition)) {
                return hasValue(ctx.postalCode);
              }

              if (ctx.donateAsOrganisation === true && ctx.organisation.isAddressRequired) {
                return hasValue(ctx.postalCode);
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isAddressRequired) {
                return hasValue(ctx.postalCode);
              }

              return true;
            },
            message: theme.showRequiredText && 'Postcode is niet ingevuld'
          },
          {
            message: 'Het opgegeven adres kan niet worden gevonden.',
            isValid: ctx => ctx.addressCleansingStatus !== 'RED'
          }
        ]
      },
      houseNumber_i: {
        isVisible: isAddressVisible,
        isRequired: ctx => {
          if (hasValue(ctx.postalCode) || hasValue(ctx.houseNumberAddition)) {
            return true;
          }

          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isAddressRequired;
          }

          return ctx.person.isAddressRequired;
        },
        rules: [
          {
            isValid: ctx => ctx.addressCleansingStatus !== 'RED'
          },
          {
            isValid: ctx => {
              if (!hasValue(ctx.houseNumber_i)) {
                return true;
              }

              return ctx.houseNumber_i.length < 8 && /^\d*$/.test(ctx.houseNumber_i);
            },
            message: 'Er is geen geldig huisnummer ingevuld. Controleer of er alleen cijfers gebruikt zijn.'
          },
          {
            isValid: ctx => {
              if (hasValue(ctx.postalCode) || hasValue(ctx.houseNumberAddition)) {
                return hasValue(ctx.houseNumber_i);
              }

              if (ctx.donateAsOrganisation === true && ctx.organisation.isAddressRequired) {
                return hasValue(ctx.houseNumber_i);
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isAddressRequired) {
                return hasValue(ctx.houseNumber_i);
              }

              return !(ctx.addressCleansingStatus === 'RED' && !_.isNil(ctx.houseNumber_i));
            },
            message: theme.showRequiredText && 'Huisnummer is niet ingevuld'
          }
        ]
      },
      houseNumberAddition: {
        isVisible: isAddressVisible
      },
      telephone: {
        isVisible: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneVisible;
          }

          return ctx.person.isTelephoneVisible;
        },
        isRequired: ctx => {
          if (ctx.donateAsOrganisation === true) {
            return ctx.organisation.isTelephoneRequired;
          }

          return ctx.person.isTelephoneRequired;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true && ctx.organisation.isTelephoneRequired) {
                return hasValue(ctx.telephone);
              }

              if (ctx.donateAsOrganisation !== true && ctx.person.isTelephoneRequired) {
                return hasValue(ctx.telephone);
              }

              return true;
            },
            message: theme.showRequiredText && 'Telefoonnummer is niet ingevuld'
          },
          {
            isValid: ctx => {
              if (!hasValue(ctx.telephone)) {
                return true;
              }

              return formatPhone(ctx.telephone).result === 'GREEN';
            },
            message: 'Er is geen geldig telefoonnummer ingevuld.'
          }
        ]
      },
      dateOfBirth: {
        isVisible: ctx => ctx.donateAsOrganisation !== true && ctx.person.isDateOfBirthVisible,
        isRequired: ctx => {
          if (ctx.donateAsOrganisation !== true) {
            return ctx.person.isDateOfBirthRequired;
          }

          return false;
        },
        rules: [
          {
            isValid: ctx => {
              if (ctx.donateAsOrganisation === true) {
                return true;
              }

              if (ctx.person.isDateOfBirthRequired) {
                return hasValue(ctx.dateOfBirth);
              }

              return true;
            },
            message: theme.showRequiredText && 'Geboortedatum is niet ingevuld'
          }
        ]
      },
      street: {
        isVisible: ctx => ctx.addressCleansingStatus === 'GREEN' && isAddressVisible(ctx)
      },
      city: {
        isVisible: ctx => ctx.addressCleansingStatus === 'GREEN' && isAddressVisible(ctx)
      },
      noAddress: {
        isVisible: ctx => ctx.addressCleansingStatus !== 'GREEN' && isAddressVisible(ctx)
      },
      allowNewsletter: {
        isVisible: () => formContext.allowNewsletter === true
      },
      showDonationFields: {
        isVisible: () => formContext.showDonationFieldsQuestionVisible === true,
        isRequired: () => formContext.showDonationFieldsQuestionVisible === true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.showDonationFields),
            message: theme.showRequiredText && 'Dit veld is vereist'
          }
        ]
      },
      frequency: {
        isVisible: ctx => ctx.showDonationFields === true || ctx.giveCompensation === true,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.frequency),
            message: theme.showRequiredText && 'Frequentie is niet ingevuld'
          }
        ]
      },
      allowCustomAmount: {
        // always visible so it's stored in the session, but it's not actually shown as a field on the page
        isVisible: () => true
      },
      isCustomAmountVisible: {
        // always visible so it's stored in the session, but it's not actually shown as a field on the page
        isVisible: () => true
      },
      setCustomAmountVisible: {
        isVisible: ctx => ctx.showDonationFields === true && formContext.customAmountDisplay === 'toggle' && ctx.allowCustomAmount === true && ctx.isCustomAmountVisible !== true
      },
      setCustomAmountHidden: {
        isVisible: ctx => ctx.showDonationFields === true && formContext.customAmountDisplay === 'toggle' && ctx.allowCustomAmount === true && ctx.isCustomAmountVisible === true
      },
      customAmount_m: {
        isVisible: (ctx) => ctx.showDonationFields === true && ctx.isCustomAmountVisible === true,
        rules: [
          {
            isValid: ctx => {
              if (!ctx.isCustomAmountVisible) {
                return true;
              }

              const amount = _.get(ctx, ['amount_m']);
              const amountHasValue = amount !== '' && !_.isNil(amount);

              if (amountHasValue && formContext.customAmountDisplay === 'inline') {
                return true;
              }

              const frequency = formContext.frequencies.find(f => f.value === _.get(ctx, ['frequency']));

              const maxAmount = BigNumber(frequency.maxAmount_m || '100000');
              const minAmount = BigNumber(frequency.minAmount_m || '1');

              const amountBn = parseAndGetBigNumber(ctx.customAmount_m);

              if (_.isNil(amountBn) || amountBn.isNaN()) {
                return true;
              }

              return amountBn.isGreaterThanOrEqualTo(minAmount) && amountBn.isLessThanOrEqualTo(maxAmount);
            },
            message: ctx => {
              const frequency = formContext.frequencies.find(f => f.value === _.get(ctx, ['frequency']));

              const maxAmount = BigNumber(frequency.maxAmount_m || '100000');
              const minAmount = BigNumber(frequency.minAmount_m || '1');

              return `Vul een bedrag in tussen € ${minAmount.toFormat(2)} en € ${maxAmount.toFormat(2)}`;
            }
          },
          {
            isValid: ctx => {
              if (!ctx.isCustomAmountVisible) {
                return true;
              }

              const amount = _.get(ctx, ['amount_m']);
              const amountHasValue = amount !== '' && !_.isNil(amount);

              if (amountHasValue && formContext.customAmountDisplay === 'inline') {
                return true;
              }

              const amountBn = parseAndGetBigNumber(ctx.customAmount_m);
              return !_.isNil(amountBn) && !amountBn.isNaN();
            },
            message: theme.showRequiredText && 'Bedrag is niet ingevuld'
          }
        ]
      },
      amountText: {
        isVisible: ctx => ctx.showDonationFields === true && !_.isNil(ctx.amountText)
      },
      amountConfirmationText: {
        isVisible: ctx => ctx.showDonationFields === true && !_.isNil(ctx.amount_m) && !_.isNil(ctx.frequency)
      },
      amount_m: {
        isVisible: ctx => {
          if (ctx.giveCompensation === true) return true; // needed for processing
          if (ctx.showDonationFields === true) {
            return formContext.customAmountDisplay === 'toggle' ? ctx.isCustomAmountVisible !== true : true;
          }
          return false;
        },
        rules: [
          {
            isValid: ctx => {
              const amountHasValue = !_.isNil(ctx.amount_m) && ctx.amount_m !== '';
              const customAmountHasValue = !_.isNil(ctx.customAmount_m) && ctx.customAmount_m !== '';

              return amountHasValue || customAmountHasValue;
            },
            message: theme.showRequiredText && 'Bedrag is niet ingevuld'
          }
        ]
      },
      paymentMethod: {
        isVisible: ctx => (ctx.showDonationFields === true || ctx.giveCompensation === true) && ctx.frequency === 'oneOff',
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.paymentMethod),
            message: theme.showRequiredText && 'Betaalmethode is niet ingevuld'
          }
        ]
      },
      iban: {
        isVisible: ctx => (ctx.showDonationFields === true || ctx.giveCompensation === true) && ctx.paymentMethod === 'directDebit',
        isRequired: ctx => ctx.paymentMethod === 'directDebit',
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.iban) && ctx.iban !== '',
            message: theme.showRequiredText && 'Rekeningnummer is niet ingevuld'
          },
          {
            message: 'Vul hier een geldig IBAN nummer in.',
            isValid: ctx => {
              var value = ctx.iban;

              if (_.isNil(value)) {
                return true;
              }

              return IBAN.isValid(value);
            }
          },
          {
            message: 'IBAN moet afkomstig zijn uit een SEPA land',
            isValid: ctx => {
              const value = ctx.iban;
              if (_.isNil(value) || value === '') return true;

              return isSepaCountryIban(value);
            }
          }
        ]
      },
      bank: {
        isVisible: ctx => (ctx.showDonationFields === true || ctx.giveCompensation === true) && ctx.paymentMethod === 'ideal' && !formContext.hideBankOptions,
        isRequired: ctx => ctx.paymentMethod === 'ideal' && !formContext.hideBankOptions,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.bank) && ctx.bank !== '',
            message: theme.showRequiredText && 'Bank is niet ingevuld'
          }
        ]
      },
      creditCardBank: {
        isVisible: ctx => (ctx.showDonationFields === true || ctx.giveCompensation === true) && ctx.paymentMethod === 'creditCard',
        isRequired: ctx => ctx.paymentMethod === 'creditCard',
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.creditCardBank) && ctx.creditCardBank !== '',
            message: theme.showRequiredText && 'Creditcard is niet ingevuld'
          }
        ]
      },
      giveCompensation: {
        isVisible: (ctx) => {
          return ctx.showDonationFields === false && formContext.showRequestCompensation;
        },
        isRequired: (ctx) => ctx.showDonationFields === false && formContext.showRequestCompensation,
        rules: [
          {
            isValid: ctx => !_.isNil(ctx.giveCompensation),
            message: theme.showRequiredText && 'Dit veld is vereist'
          }
        ]
      },
      productAmount: {
        isVisible: () => formContext.showProductQuantity === true,
        isRequired: () => formContext.showProductQuantity === true
      },
      donationReason: {
        isVisible: true,
        isRequired: true
      },
      mandateText: {
        isVisible: ctx => (ctx.showDonationFields === true || ctx.giveCompensation === true) && (!_.isNil(ctx.amount_m) || !_.isNil(ctx.customAmount_m)) && !_.isNil(ctx.frequency) && ctx.paymentMethod === 'directDebit'
      }
    }
  };

  const Email = (props) => (
    <div className='marginBottom'>
      <Field
        label='E-mailadres'
        name='email'
        inputComponent={Input}
        component={FieldWrapper}
        placeholder='E-mailadres'
        inputType='email'
        autoComplete='email'
        hideLabel={props.hideLabel}
      />
      <NewsletterOptIn label={formContext.newsletterTextLead} />
    </div>
  );

  const PersonForm = (props) => {
    const blocks = {
      gender: <Gender genderDisplay={props.genderDisplay} hideLabel={props.hideGenderFieldLabel} />,
      name: <Name isFirstNameVisible={props.isFirstNameVisible}
        isFirstNameRequired={props.isFirstNameRequired}
        isInitialsRequired={props.isInitialsRequired}
        hideLabel={props.hideNameFieldLabel} />,
      address: <Address {...props} hideLabel={props.hideAddressFieldLabel} />,
      phone: <Phone {...props} hideLabel={props.hidePhoneFieldLabel} />,
      dateOfBirth: <DateOfBirth hideLabel={props.hideDateOfBirthFieldLabel} />,
      email: <Email hideLabel={props.hideEmailFieldLabel} />
    };
    return <>{orderContactBlocks(formContext.person.fieldOrder, blocks).map(({key, node}) => <React.Fragment key={key}>{node}</React.Fragment>)}</>;
  };

  const OrganisationForm = (props) => {
    const blocks = {
      organisationName: <OrganisationName hideLabel={props.hideOrganisationNameFieldLabel} />,
      address: <Address {...props} hideLabel={props.hideAddressFieldLabel} />,
      name: <Name isFirstNameVisible={props.isFirstNameVisible}
        isFirstNameRequired={props.isFirstNameRequired}
        isInitialsRequired={props.isInitialsRequired}
        hideLabel={props.hideNameFieldLabel} />,
      email: <Email hideLabel={props.hideEmailFieldLabel} />,
      phone: <Phone {...props} hideLabel={props.hidePhoneFieldLabel} />
    };
    return <>{orderContactBlocks(formContext.organisation.fieldOrder, blocks).map(({key, node}) => <React.Fragment key={key}>{node}</React.Fragment>)}</>;
  };

  let content = (<>
    <Box position={formContext.textPosition}
      hasTeaser={!_.isNil(formContext.pageTeaserHeader) || !_.isNil(formContext.pageTeaserBodyText) || !_.isEmpty(formContext.pageTeaserCarouselItems)}>
      {!(theme.hideProgressBarLead && theme.title.showInBody) &&
        <Title title={formContext.step1Header}>{theme.hideProgressBarLead !== true && <ProgressBar progress={progressBar} />}</Title>
      }
      <Form
        autoComplete='off'
        formInstanceKey='donate'
        formContext={formContext}
        formConfig={formConfig}>
        <PaymentFailedMessage formContext={formContext} />
        {!theme?.error?.showBelowBodyText && <FormValidation
          component={ErrorMessage}
          errorMessageTemplate={formContext.errorMessageTemplate}
          formContext={formContext}
          errorMessage='Je hebt nog niet alle velden ingevuld.' />}
        <div className='widgetContent'>
          {!_.isNil(formContext.step1BodyText) && <div>
            {theme?.title?.showInBody && <TextToHtml text={formContext.step1Header} wrap={wrapTitle} />}
            <TextToHtml text={formContext.step1BodyText} />
          </div>}
          {theme?.error?.showBelowBodyText && <FormValidation
            component={ErrorMessage}
            errorMessageTemplate={formContext.errorMessageTemplate}
            formContext={formContext}
            errorMessage='Je hebt nog niet alle velden ingevuld.' />}
          <div className='marginBottom'>
            <Field
              list='productAmount'
              name='productAmount'
              label='Aantal producten'
              component={FieldWrapper}
              inputComponent={Dropdown}
              renderOneItemAsDiv={false}
              sideBySide
            />
          </div>
          {_.get(formContext, ['donateAsOrganisationDisplay']) === 'radiobutton'
            ? <div className='marginBottom'><Field
              name='donateAsOrganisation'
              list='donateAsOrganisationChoices'
              label={_.get(formContext, ['donateAsOrganisationLabel'], 'Ik doneer als')}
              component={FieldWrapper}
              inputComponent={(props) => (
                <RadioButtonContainer
                  fieldName='donateAsOrganisation'
                  valueName='donateAsOrganisation'
                  list={props.list}
                  {...props}
                  setValue={(v) => props.setValue(v === true || v === 'true')} />
              )}
            /></div>
            : <Field
              name='donateAsOrganisation'
              label={_.get(formContext, ['donateAsOrganisationLabel'], 'Ik bestel namens een organisatie')}
              component={FieldWrapper}
              inputComponent={Checkbox}
              hideLabel
            />}
          <Field
            name='renderAsPerson'
            telemarketingOptIn={formContext.telemarketingOptIn}
            telemarketingInfoText={formContext.telemarketingInfoText}
            telemarketingCheckBoxText={formContext.telemarketingCheckBoxText}
            isAddressVisible={formContext.person.isAddressVisible}
            isAddressOptional={!formContext.person.isAddressRequired}
            isFirstNameVisible={formContext.person.isFirstNameVisible}
            isFirstNameRequired={formContext.person.isFirstNameRequired}
            isInitialsRequired={formContext.person.isInitialsRequired}
            genderDisplay={formContext.genderDisplay}
            hideNameFieldLabel={formContext.hideNameFieldLabel}
            hideAddressFieldLabel={formContext.hideAddressFieldLabel}
            hideEmailFieldLabel={formContext.hideEmailFieldLabel}
            hideOrganisationNameFieldLabel={formContext.hideOrganisationNameFieldLabel}
            hidePhoneFieldLabel={formContext.hidePhoneFieldLabel}
            hideDateOfBirthFieldLabel={formContext.hideDateOfBirthFieldLabel}
            hideGenderFieldLabel={formContext.hideGenderFieldLabel}
            component={PersonForm}
          />
          <Field
            name='renderAsOrganisation'
            telemarketingOptIn={formContext.telemarketingOptIn}
            telemarketingInfoText={formContext.telemarketingInfoText}
            telemarketingCheckBoxText={formContext.telemarketingCheckBoxText}
            isAddressVisible={formContext.organisation.isAddressVisible}
            isAddressOptional={!formContext.organisation.isAddressRequired}
            isFirstNameVisible={formContext.organisation.isFirstNameVisible}
            isFirstNameRequired={formContext.organisation.isFirstNameRequired}
            isInitialsRequired={formContext.organisation.isInitialsRequired}
            hideNameFieldLabel={formContext.hideNameFieldLabel}
            hideAddressFieldLabel={formContext.hideAddressFieldLabel}
            hideEmailFieldLabel={formContext.hideEmailFieldLabel}
            hideOrganisationNameFieldLabel={formContext.hideOrganisationNameFieldLabel}
            hidePhoneFieldLabel={formContext.hidePhoneFieldLabel}
            hideDateOfBirthFieldLabel={formContext.hideDateOfBirthFieldLabel}
            hideGenderFieldLabel={formContext.hideGenderFieldLabel}
            component={OrganisationForm}
          />

          <Field
            name='showDonationFields'
            component={FieldWrapper}
            inputComponent={(props) => {
              return <>
                {!_.isNil(formContext.stepUpTextHtml_txt) && <div><TextToHtml text={formContext.stepUpTextHtml_txt} /></div>}
                <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}} className='marginBottom'>
                  <RadioButton
                    name={props.name}
                    key={`${props.name}-yes`}
                    hasErrors={props.hasErrors}
                    isChecked={props.value === true}
                    withBorder
                    label={formContext.showDonationFieldsLabelYes || 'Ja, ik draag met mijn donatie bij aan een oplossing'}
                    validate={props.validate}
                    disabled={props.disabled}
                    setValue={() => props.setValue(true)} />
                  <RadioButton
                    name={props.name}
                    key={`${props.name}-no`}
                    hasErrors={props.hasErrors}
                    isChecked={props.value === false}
                    withBorder
                    label={formContext.showDonationFieldsLabelNo || 'Nee, ik wil niet bijdragen'}
                    validate={props.validate}
                    disabled={props.disabled}
                    setValue={() => props.setValue(false)} />
                </div>
                {props?.value === true && <>
                  <div className='marginBottom'>
                    <Field
                      list='frequencies'
                      name='frequency'
                      component={(props) => {
                        const list = _.get(props, ['list']);
                        // do not render options if there is only 1 frequency
                        if (_.size(list) < 2 && formContext.frequencyDisplay === 'dropdown') {
                          return null;
                        }
                        const enrichedFrequencies = list.map(item => ({...item, ribbon: _.find(formContext.frequencies, f => f.value === item.value)?.ribbon || ''}));
                        return <>
                          {formContext.frequencyDisplay === 'dropdown' && <Dropdown {...props} />}
                          {formContext.frequencyDisplay === 'radiobutton' && <RadioButtonContainer {...props} />}
                          {formContext.frequencyDisplay === 'button' && <ButtonContainer fieldName='frequency' list={enrichedFrequencies} />}
                        </>;
                      }}
                    />
                  </div>
                  <div className='marginBottom'>
                    <Field
                      name='frequency'
                      component={() => <SelectedFrequencyContent formContext={formContext} />}
                    />
                  </div>
                  <div className='marginBottom'>
                    <Field
                      list='amounts'
                      name='amount_m'
                      component={FieldWrapper}
                      inputComponent={(props) => {
                        const list = props.list.map(a => {
                          a.ribbon = a.value.ribbon;
                          a.icon = a.value.icon;
                          a.fieldName = a.value.fieldName;
                          a.value = a.value.value;
                          return a;
                        });

                        return <ButtonContainer
                          fieldName='amount_m'
                          valueName='amount_m'
                          list={list} />;
                      }}
                    />
                  </div>
                </>}
              </>;
            }}
          />

          <div className='marginBottom'>
            <Field
              name='setCustomAmountVisible'
              component={({updateField}) => <div className='centered'>
                <button type='button' className='link' onClick={() => {
                  updateField('isCustomAmountVisible', true);
                  updateField('amount_m', null);
                }}>
                  Of kies een ander bedrag
                </button>
              </div>
              }
            />
          </div>

          <div className='marginBottom'>
            <Field
              name='amount_m'
              component={() => <SelectedAmountText formContext={formContext} />}
            />
          </div>

          <div className='marginBottom'>
            <Field
              label={formContext.customAmountDisplay !== 'inline' ? 'Vul het bedrag in dat je wilt doneren' : null}
              name='customAmount_m'
              placeholder={formContext.customAmountDisplay === 'inline' ? 'Of vul hier een ander bedrag in' : '0,00'}
              component={FieldWrapper}
              inputComponent={InputAmount}
            />
          </div>

          <div className='marginBottom'>
            <Field
              name='setCustomAmountHidden'
              component={({updateField}) => <div className='centered'>
                <button type='button' className='link' onClick={() => {
                  updateField('isCustomAmountVisible', false);
                  updateField('customAmount_m', null);
                }}>Of kies bedrag
                </button>
              </div>}
            />
          </div>

          <div className='marginBottom'>
            <Field
              list='periods'
              component={(props) => {
                const list = _.get(props, ['list']);
                // do not render options if there is only 1 frequency
                if (_.size(list) === 0) {
                  return null;
                }
                if (_.size(list) === 1) {
                  return <SinglePeriod label={list[0].label} />;
                }
                return <>
                  {formContext.periodDisplay === 'dropdown' && <Dropdown {...props} placeholder='Selecteer een periode...' />}
                  {formContext.periodDisplay === 'radiobutton' && <RadioButtonContainer {...props} />}
                  {formContext.periodDisplay === 'button' && <ButtonContainer fieldName='period' list={list} />}
                </>;
              }}
              name='period'
            />
          </div>

          <div className='marginBottom'>
            {formContext.showDonationConfirmationAmountText && <DonationConfirmationAmountText />}
          </div>

          <div className='marginBottom'>
            <Field
              name='giveCompensation'
              component={FieldWrapper}
              inputComponent={(props) => {
                return <>
                  {!_.isNil(formContext.requestCompensationTextHtml_txt) && <div><TextToHtml text={formContext.requestCompensationTextHtml_txt} /></div>}
                  <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                    <RadioButton
                      name={props.name}
                      key={`${props.name}-yes`}
                      hasErrors={props.hasErrors}
                      isChecked={props.value === true}
                      withBorder
                      label={parseText(formContext, formContext.yesCompensationLabel) || `Ja, ik draag ${formContext.compensationAmount_m} bij aan onkostenvergoeding`}
                      validate={props.validate}
                      disabled={props.disabled}
                      setValue={() => props.setValue(true)} />
                    <RadioButton
                      name={props.name}
                      key={`${props.name}-no`}
                      hasErrors={props.hasErrors}
                      isChecked={props.value === false}
                      withBorder
                      label={parseText(formContext, formContext.noCompensationLabel) || 'Nee, ik wil niet bijdragen'}
                      validate={props.validate}
                      disabled={props.disabled}
                      setValue={() => props.setValue(false)} />
                  </div>
                </>;
              }} />
          </div>

          <div className='marginBottom'>
            <Field
              name='paymentMethod'
              component={(props) => {
                return <PaymentMethodButtonContainer
                  fieldName='paymentMethod'
                  valueName='paymentMethod'
                  list={props.list} />;
              }}
              list='paymentMethods'
            />
          </div>

          <div className='marginBottom'>
            <Field
              list='idealBanks'
              name='bank'
              component={FieldWrapper}
              placeholder={'Kies je bank'}
              inputComponent={Dropdown}
            />
          </div>

          <div className='marginBottom'>
            <Field
              list='creditCardBanks'
              name='creditCardBank'
              component={FieldWrapper}
              placeholder={'Kies je creditcard'}
              inputComponent={Dropdown}
            />
          </div>

          <div className='marginBottom'>
            <Field
              label='Rekeningnummer'
              name='iban'
              component={FieldWrapper}
              inputComponent={Input}
              placeholder='NL11ABNA012345678'
              forceUppercase />
            <Field
              name='mandateText'
              component={MandateTextConnected} />
          </div>

          <div className='marginBottom'>
            {!theme.hideDirectDebitTextOnLeadPage && <DirectDebitText formContext={formContext} />}
          </div>

          <div className={'donationReason'} aria-hidden='true'>
            <Field
              name='donationReason'
              component={FieldWrapper}
              inputComponent={Input}
              label={'Reden donatie'}
              placeholder={'Reden donatie'}
              hideValidation
              tabIndex={'-1'}
              autoComplete={'e0e3896c-f25b-422d-8da1-bdc2466652d8'}
            />
          </div>

          <div className='marginBottom'>
            <FormValidation
              type='submit'
              label={formContext.leadCallToActionLabel || 'Aanvragen'}
              component={Button}
            />
          </div>
          {formContext.telemarketingOptIn === 'button' && <Telemarketing
            telemarketingOptIn={formContext.telemarketingOptIn}
            telemarketingInfoText={formContext.telemarketingInfoText}
            telemarketingCheckBoxText={formContext.telemarketingCheckBoxText}
          />}
          {formContext.privacyConfirmationTextLead &&
            <div className='marginBottom'>
              <PrivacyLabel page='lead' text={parseAuthorizeLabel(formContext.privacyConfirmationTextLead, renderDialog)} />
            </div>}
          {formContext.entryCallToAction &&
            <div className='marginBottom centered'>
              {formContext.entryCallToActionUrl ? <a className='link' href={formContext.entryCallToActionUrl} rel='noopener noreferrer'>{formContext.entryCallToAction}</a> : formContext.entryCallToAction}
            </div>}
          <BottomImage url={formContext.bottomImageUrl} altText={formContext.bottomImageAltText} />
        </div>
      </Form>
    </Box>
    <SmsOptOut text={formContext.smsOptOutText} processedText={formContext.smsOptOutProcessedText} />
  </>);

  if (isDialogVisible) {
    content = <ModalDialog close={() => {
      closeDialog();
    }}>
      <div dangerouslySetInnerHTML={{__html: formContext.privacyStatement}} />
    </ModalDialog>;
  }

  return <>
    <Helmet>
      <title>{formContext.contactDataBrowserTitle}</title>
    </Helmet>
    <MainContainer
      backgroundImageUrl={formContext.backgroundImageUrl}
      backgroundImageTabletUrl={formContext.backgroundImageTabletUrl}
      backgroundImageMobileUrl={formContext.backgroundImageMobileUrl}
    />
    <LayoutContainer
      position={formContext.textPosition}
      header={<div>
        <div style={{float: 'left', display: 'inline-block'}}>
          <Logo url={formContext.websiteUrl} />
        </div>
      </div>}
      content={content}
      sidebar={
        <>
          {theme?.djsb?.showDJSB && <DJSBSideBar formContext={formContext} />}
          <ProductImage url={_.get(formContext, ['productImageUrl'])} collapseIfEmpty />
          <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} />
        </>}
      faq={formContext.frequentlyAskedQuestions}
      footer={formContext.footer}
      formContext={formContext}
    />
  </>;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext,
    isDialogVisible: state.reducer.isDialogVisible
  };
};

const mapDispatchToProps = (dispatch) => ({
  save: (history, submittedFormData) => {
    dispatch(saveLead(history, submittedFormData));
  },
  gaLead1: (formContext) => {
    dispatch(gaLead1(formContext));
  },
  cleanseAddress: (data, callback) => {
    dispatch(cleanseAddress(data, callback));
  },
  cleanseName: (data, callback) => {
    dispatch(cleanseName(data, callback));
  },
  resetSubmittingForm: () => dispatch(resetSubmitting('donate')),
  renderDialog: (e) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(renderDialog());
  },
  closeDialog: () => {
    dispatch(closeDialog());
  },
  untouchAmountFields: () => {
    dispatch(untouch({instanceKey: 'donate', field: 'customAmount_m'}));
    dispatch(untouch({instanceKey: 'donate', field: 'amount_m'}));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTheme(Lead1)));

const Address = (props) => {
  if (!props.isAddressVisible) return <></>;
  return (
    <>
    <div className='marginBottom'>
      <StyledAddressLabel>
        {!props.hideLabel && <Label label='Adres' isOptional={props.isAddressOptional} />}
      </StyledAddressLabel>
      <AddressRow>
        <div>
          {!props.hideLabel && <Field
            name='postalCode'
            component={() => <SubLabel label='Postcode' />}
            hideValidation
          />}
          <Field
            name='postalCode'
            component={FieldWrapper}
            inputComponent={Input}
            placeholder={'Postcode'}
            inline
            hideValidation
            hideLabel={props.hideLabel}
            autoComplete='postal-code'
          />
        </div>
        <div>
          {!props.hideLabel && <HouseNumberRow>
            <Field
              name='houseNumber_i'
              component={() => <SubLabel label='Huisnummer' />}
              hideValidation
            />
            <Field
              name='houseNumberAddition'
              component={() => <SubLabel label='Toevoeging' isOptional />}
              hideValidation
            />
          </HouseNumberRow>}
          <HouseNumberRow>
            <Field
              name='houseNumber_i'
              component={FieldWrapper}
              inputComponent={Input}
              placeholder={'Huisnummer'}
              inline
              hideValidation
              hideLabel={props.hideLabel}
              inputType='tel'
              autoComplete='05d2ae54-5b99-4418-9d38-fde0ab6d553f'
            />
            <Field
              name='houseNumberAddition'
              component={FieldWrapper}
              inputComponent={Input}
              placeholder={'Toevoeging'}
              hideValidation
              hideLabel={props.hideLabel}
              autoComplete='f1a99033-6af3-4aa2-94db-1de7ff1af61d'
            />
          </HouseNumberRow>
        </div>
      </AddressRow>
      <Field
        name='postalCode'
        component={Validation} />
      <Field
        name='houseNumber_i'
        component={Validation} />
      <Field
        name='houseNumberAddition'
        component={Validation} />
      <FoundAddress>
        <FoundAddressTitle>Adres:</FoundAddressTitle>
        <Field name='noAddress' component={() => <NoFoundAddress>Wordt automatisch aangevuld</NoFoundAddress>} />
        <Field
          component={({value}) => <div className='addressBox'>{value}&nbsp;</div>}
          name='street' />
        <Field
          component={({value}) => <div className='addressBox'>{value}</div>}
          name='city' />
      </FoundAddress>
    </div>
    </>
  );
};

const Phone = (props) => {
  return <>
    <div className='marginBottom'>
      <Field
        label='Telefoonnummer'
        name='telephone'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder='Telefoonnummer'
        inputType='tel'
        autoComplete='tel'
        hideLabel={props.hideLabel}
      />
      {(props.telemarketingOptIn === 'text' || props.telemarketingOptIn === 'checkbox' || props.telemarketingOptIn === 'dropdown') && <Telemarketing {...props} />}
    </div>
  </>;
};

const DateOfBirth = (props) => (
  <div className='marginBottom'>
    <Field
      label='Geboortedatum'
      name='dateOfBirth'
      component={FieldWrapper}
      inputComponent={DateInput}
      autoComplete='5d65176f-1708-4b09-93c4-9b9e4f97e4dc'
      hideLabel={props.hideLabel}
    />
  </div>
);

const Gender = (props) => (
  <div className='marginBottom'>
    <Field
      label='Geslacht'
      name='gender'
      list='genders'
      component={FieldWrapper}
      inputComponent={(fieldProps) => {
        return props.genderDisplay === 'dropdown'
          ? <Dropdown fieldName='gender' valueName='gender' {...fieldProps} placeholder='Kiezen...' />
          : <RadioButtonContainer fieldName='gender' valueName='gender' list={fieldProps.list} {...fieldProps} />;
      }}
      hideLabel={props.hideLabel}
    />
  </div>
);

const NameRow = styled.div`
  display: flex;
  gap: ${props => props.theme.horizontalFieldGap || '5px'};

  > * {
    flex: 1;

    &:last-child {
      flex: ${props => props.theme.nameRow?.lastNameFlex || '3'};
    }
  }
`;

const Name = (props) => (
  <div className='marginBottom'>
    {!props.hideLabel && <Label label={'Naam'} />}
    {props.isFirstNameVisible && <div className='marginBottomTen'>
      <Field
        name='firstName'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Voornaam'}
        hideValidation
        autoComplete='given-name'
        hideLabel={props.hideLabel}
      />
    </div>}
    <NameRow>
      <Field
        name='initials'
        component={() => <SubLabel label='Voorletters' isOptional={!props.isInitialsRequired} />}
        hideValidation
      />
      <Field
        name='infix'
        component={() => <SubLabel label='Tussenvoegsel' isOptional />}
        hideValidation
      />
      <Field
        name='lastName'
        component={() => <SubLabel label='Achternaam' />}
        hideValidation
      />
    </NameRow>
    <NameRow>
      <Field
        name='initials'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Voorletters'}
        hideValidation
        inline
        autoComplete='00db6d76-1330-4b71-89aa-72fe7b9f238a'
        hideLabel={props.hideLabel}
      />
      <Field
        name='infix'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Tussenvoegsel'}
        hideValidation
        autoComplete='90ab3315-3929-4643-b78d-9de3e727eadf'
        hideLabel={props.hideLabel}
      />
      <Field
        name='lastName'
        component={FieldWrapper}
        inputComponent={Input}
        placeholder={'Achternaam'}
        hideValidation
        autoComplete='family-name'
        hideLabel={props.hideLabel}
      />
    </NameRow>
    <Field
      name='firstName'
      component={Validation} />
    <Field
      name='initials'
      component={Validation} />
    <Field
      name='infix'
      component={Validation} />
    <Field
      name='lastName'
      component={Validation} />
  </div>
);

const OrganisationName = (props) => (
  <div className='marginBottom'>
    <Field
      label='Naam organisatie'
      name='organisationName'
      inputComponent={Input}
      component={FieldWrapper}
      placeholder='Naam organisatie'
      autoComplete='8407db7a-756c-4190-85f1-c7916a0c245e'
      hideLabel={props.hideLabel}
    />
  </div>
);

const MandateTextStyled = styled.div`
  font-size: ${props => props.theme?.membership?.mandateText?.fontSize};
  color: ${props => props.theme?.membership?.mandateText?.color};
  font-style: ${props => props.theme?.membership?.mandateText?.fontStyle};
`;
const MandateText = ({formContext, formData}) => <MandateTextStyled>
  {parse(replaceNewLinesForHtml(parseText({...formContext, ...formData}, formContext.leadMandateText)))}
</MandateTextStyled>;

const mapStateToProps2 = (state) => {
  return {
    formContext: state.reducer.formContext,
    formData: getFormData(state, 'donate')
  };
};
const MandateTextConnected = connect(mapStateToProps2)(MandateText);
